import React, {Component} from 'react';
import PropTypes from 'prop-types';
import template from '../../templates/SearchBar/SearchBar.rt';

class searchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: (typeof props.value === 'undefined') ? props.defaultValue : props.value
    }
  }

  handleChange = (e) => {
    const value = e.target.value;

    this.setState({value});

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      this.setState({value: this.props.value});
    }
  }

  value = () => {
    if (this.state.value && this.state.value.search && this.state.value.search.term)
      return this.state.value.search.term;
    if (this.state.value)
      return this.state.value;
    return '';
  }

  render = template
}

searchBar.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  componentClassName: PropTypes.string
};

const SearchBar = searchBar;
export default SearchBar;
